import React from 'react';
import { Link } from 'gatsby';

import Footer from './footer';
import Navbar from './navbar';
import SEO from './seo';
import { MDXProvider } from '@mdx-js/react';

const shortcodes = { Link, SEO };

const Layout = ({ children }) => {
  return (
    <MDXProvider components={shortcodes}>
      <div className="bg-gray-900 text-gray-300 font-body">
        <div className="mx-5 xl:mx-auto max-w-screen-xl flex flex-col min-h-screen">
          <Navbar />
          {children}
          <Footer />
        </div>
      </div>
    </MDXProvider>
  );
};

export default Layout;
